import { render } from "./EditDefaultItemsModal.vue?vue&type=template&id=1488322a"
import script from "./EditDefaultItemsModal.vue?vue&type=script&lang=js"
export * from "./EditDefaultItemsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__